var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact_us"},[_c('h1',[_vm._v("Get in touch")]),_c('p',{staticClass:"my-3"},[_vm._v("We would love to hear from you.")]),_c('ContactForm')],1)}
var staticRenderFns = []

export { render, staticRenderFns }